<template>
    <div style="display: flex; gap: 20px; align-items: center;" @contextmenu.prevent>
        <DataCollector :trainer="trainer" :focusData="focusData" @update:focusData="focusData = $event"/>
        <DataLabeler :trainer="trainer" :data="focusData"/>
        <Box :color="'#8a66c7'" :background="'#F5E9FF'" :width="'max-content'">
            <button>Train</button>
            <template #title>Model</template>
            <template #content>
                <div style="padding: 10px;">
                    <ObjectDetection />
                </div>
            </template>
        </Box>
    </div>
</template>

<script>
import DataLabeler from './DataLabeler/DataLabeler.vue'
import {ObjectDetectionTrainer} from '../scripts/ObjectDetection.js';
import DataCollector from './DataCollector/DataCollector.vue';
import ObjectDetection from './ObjectDetection2.vue';
import {Box} from '@/index';

export default {
    components:{
        DataCollector,
        DataLabeler,
        Box,
        ObjectDetection
    },
    data(){
        return{
            trainer: new ObjectDetectionTrainer(),
            focusData: null,
            focusClass: null,
        }
    },
    computed: {
        data(){
            return this.trainer.data;
        }
    },
    watch: {
        data :{
            handler() {
                if (!this.data.includes(this.focusData)) {
                    this.focusData = null
                    console.log(this.focusData)
                }
            }, 
            deep: true
        }
    }
}
</script>

<style scoped>
button{
    background: #f5e8fe;
    border: 2px solid #8a66c7;
    color: #8a66c7;
    border-radius: 5px;
    min-height: 26px;
    cursor: pointer;
}

button:hover{
    background: #e9d5fb;

}

button.inactive{
    pointer-events: none;
    filter: grayscale(1);
}
</style>

<style scoped>
.imageContainer{
    min-height: 90px; width: 100%; display: flex; 
    gap: 5px; 
    overflow-x: scroll; 
    overflow-y: hidden;
    padding: 5px;
    border-radius: 5px;
    box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.25) 0px 0px 0px 1px;
}

.imageContainer.vertical{
    flex: 1;
    overflow-x: hidden; 
    overflow-y: scroll;
    flex-wrap: wrap;
    align-content: flex-start;
}

.imageContainer::-webkit-scrollbar {
    -webkit-appearance: none;
}

.imageContainer::-webkit-scrollbar:vertical {
    width: 10px;
    height: 100%;
}

.imageContainer::-webkit-scrollbar:horizontal {
    height: 10px;
    width: 100%;
}

.imageContainer::-webkit-scrollbar-thumb {
    border-radius: 8px;
    border: 2px solid white;
    background-color: rgba(0, 0, 0, .3);
}

.imageContainer::-webkit-scrollbar-thumb:hover {
    border-radius: 8px;
    border: 2px solid white;
    background-color: rgba(0, 0, 0, .5);
}

.imageContainer::-webkit-scrollbar-track { 
    border-radius: 10px; 
} 

.region{
    border: 1.5px dotted #fff; border-radius: 0; 
    background: rgba(255, 255, 255, 0.5); 
    position: absolute; opacity: 0.7;
}
</style>